var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransaviaBedBreakfast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.657 4H4V12.3353C4 14.9117 6.08833 17 8.66467 17H13.3357C15.9117 17 18 14.9117 18 12.3353V12H19.657C21.8627 12 23.657 10.2057 23.657 8C23.657 5.79433 21.8627 4 19.657 4ZM19.657 10.3333H18V5.66667H19.657C20.9433 5.66667 21.9903 6.71333 21.9903 8C21.9903 9.28667 20.9433 10.3333 19.657 10.3333ZM20.3333 20H1.66667C0.746 20 0 19.2537 0 18.3333H22C22 19.2537 21.2537 20 20.3333 20Z",
    fill: "#2800A0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaviaBedBreakfast);
export default __webpack_public_path__ + "static/media/transavia_Bed&Breakfast.dcba18978219fbb75c30675b55aace6d.svg";
export { ForwardRef as ReactComponent };